import React, {useEffect, useState} from 'react';
import {FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup, TextField, } from "@material-ui/core";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import Button from "@material-ui/core/Button";
import BBIconAdd from "../../../assets/bbCustomIcons/BBIconAdd";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import {CircularProgress, DialogTitle} from "@mui/material";
import IntlMessages from "../../../util/IntlMessages";
import BBExternalLink from "../accents/BBExternalLink";
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import {addBRTargetIpProvided, createUserForCustomer, fetchUsersForCustomer} from "../../../actions";
import BBIconQRCodeOTP from "../../../assets/bbCustomIcons/BBIconQRCodeOTP";
import BBIconEmail from "../../../assets/bbCustomIcons/BBIconEmail";
import BBIconSMSText from "../../../assets/bbCustomIcons/BBIconSMSText";
import BBIconCallPhone from "../../../assets/bbCustomIcons/BBIconCallPhone";
import FormControl from "@material-ui/core/FormControl";


const Form = (props)=>{

    const {customerInView} = useSelector(({customer}) => customer);
    const dispatch = useDispatch();

    const [firstName, setFirstName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [email, setEmail] = useState(null);
    const [isManager, setIsManager] = useState(null);


    const clearForm = () => {

        setFirstName("");
        setLastName("");
        setEmail("");
        setIsManager("");
        document.getElementById('NewUserCustomerManagedForm').reset();
    }
    //
    // useEffect(() => {
    //
    // }, [dispatch, ]);

    const { register, handleSubmit, errors } = useForm();
    const onSubmit = data => {
        dispatch(createUserForCustomer(customerInView, email, isManager, firstName, lastName))
        clearForm();
    }

    return(
        <div className="animated fadeIn animation-duration-7 m-2">
            <form id={"NewUserCustomerManagedForm"} className={""}>
                <div className={"row"}>
                    <div className={"col"}>
                        <TextField
                            label={<IntlMessages id="appModule.firstName"/>}
                            fullWidth
                            id="firstName"
                            name="firstName"
                            required
                            error={!!errors.firstName}
                            onChange={(event) => setFirstName(event.target.value)}
                            defaultValue={firstName}
                            margin="normal"
                            className="mt-1 my-sm-3"
                            inputRef={register({
                                required: "This field is required." ,
                                // pattern: /^([a-z0-9\s]+,)*([a-z0-9\s]+){1}$/i
                            })}
                            helperText={errors.firstName?.message}
                        />
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col"}>
                        <TextField
                            label={<IntlMessages id="appModule.lastName"/>}
                            fullWidth
                            id="lastName"
                            name="lastName"
                            required
                            error={!!errors.lastName}
                            onChange={(event) => setLastName(event.target.value)}
                            defaultValue={lastName}
                            margin="normal"
                            className="mt-1 my-sm-3"
                            inputRef={register({
                                required: "This field is required." ,
                                // pattern: /^([a-z0-9\s]+,)*([a-z0-9\s]+){1}$/i
                            })}
                            helperText={ errors.lastName?.message}
                        />
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col"}>
                        <TextField
                            label={<IntlMessages id="appModule.email"/>}
                            fullWidth
                            id="email"
                            name="email"
                            required
                            error={!!errors.email}
                            onChange={(event) => setEmail(event.target.value)}
                            defaultValue={email}
                            margin="normal"
                            className="mt-1 my-sm-3"
                            inputRef={register({
                                required: "This field is required." ,
                                // pattern: /^([a-z0-9\s]+,)*([a-z0-9\s]+){1}$/i
                            })}
                            helperText={ errors.email?.message}
                        />
                    </div>
                    {/*<div className={"col-6"}>*/}

                    {/*</div>*/}
                </div>
                <br/>
                <div className={"row mt-1 pt-1"}>
                    {/*<div className={"col-6"}> </div>*/}
                    <div className={"col"}>
                        <FormControl>
                            <FormLabel id="demo-radio-buttons-group-label"><IntlMessages id="appModule.newUserCompanyManaged.isManager"/></FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue={"0"}
                                id="isManager"
                                name="isManager"
                                value={isManager}
                                required
                                onChange={(event) => setIsManager(event.target.value)}
                            >
                                <FormControlLabel value={"1"} control={<Radio checked={isManager === "1"}/>} label={"True"} />
                                <FormControlLabel value={"0"} control={<Radio checked={isManager === "0"}/>} label={"False"} />
                            </RadioGroup>

                            <FormHelperText
                                // error={!!registrationFormHooks.errors.preference}
                            >
                                {/*{registrationFormHooks.errors.preference? registrationFormHooks.errors.preference?.message : " "}*/}
                            </FormHelperText>
                        </FormControl>
                    </div>
                </div>
                <div className="mb-3 d-flex align-items-center justify-content-between">

                    <Button onClick={handleSubmit(onSubmit)}
                            disabled={!!errors.email}
                            variant="contained" color="primary">
                        <IntlMessages id="form.submit"/>
                    </Button>
                </div>

            </form>

        </div>
    )
}

const NewUserFormUserManagementTable = ({iconOnly = false, }) =>{

    const [open, setOpen] = useState(false);
    const { loadingCreateUserForCustomer, loadingCreateUserForCustomerError, customerInView} = useSelector(({customer}) => customer);

    return(
        <div>
            <Tooltip title={"Add a new user to your company's account."}>
                <Button
                    id={'tourNewUserFormButton'}
                    variant="outlined"
                    color="default"
                    onClick={()=>setOpen(true)}
                    className={"text-electric-blue "}
                >
                    {iconOnly
                        ? <BBIconAdd style={{fontSize: "70px"}}/>
                        : <><BBIconAdd className={"mr-2"}/>Add New User</>
                    }

                </Button>
            </Tooltip>

            <Dialog
                fullWidth={false}
                maxWidth={"sm"}
                open={open}
                onClose={()=>setOpen(false)}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="customized-dialog-title" onClose={()=>setOpen(false)}>
                    Add a new user to your company's BreachRisk&trade; account.                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {/*<p>Add a new user to your company's BreachRisk&trade; account.</p>*/}
                        <p>
                            {/*<em>*/}
                            {/*    <small>*/}
                                    An email will be sent to the address provided to allow them to sign up for an account with your company's information. Any email that has an existing account will automatically be added to your company's BreachRisk&trade;.
                            {/*    </small>*/}
                            {/*</em>*/}
                        </p>
                    </DialogContentText>
                    <div className={"border-2 p-3"}>
                        {!loadingCreateUserForCustomer[customerInView]
                            ?<Form></Form>
                            : <div className={"p-2 text-center"}>
                                <CircularProgress/>
                            </div>}
                    </div>

                </DialogContent>
                <DialogActions>
                    {/*<Button onClick={handleClose} color="primary">*/}
                    {/*    Cancel*/}
                    {/*</Button>*/}
                    <Button onClick={()=>setOpen(false)} color="primary">
                        Done
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default NewUserFormUserManagementTable